import { render, staticRenderFns } from "./returned-menu.vue?vue&type=template&id=41faa480&"
import script from "./returned-menu.vue?vue&type=script&lang=js&"
export * from "./returned-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports